<div class="flex-container cm-dashboard-page">
  <div class="container-fluid">
    <div class="container">
      <app-home-heading-contianer></app-home-heading-contianer>

      <app-toast-message *ngIf="firstLoginToaster"
        [descriptionData]="'Enable company identity provider (IDP) integration for faster and more secure logins for your organization.'"
        [toastrClass]="'toast-msg__complete__warning position-alert-box'" [buttonText]="'Enable'" [Isvisible]="false" [isbtnShow]="true"
        (contactAdmin)="handleEnableIDP()">
      </app-toast-message>

      <app-profile-strip-summary></app-profile-strip-summary>

      <app-booking-tab-layout *ngIf="!isMultiCity" (tripTypeChanged)="handleTripTypeChange($event)">
        [triptype]="triptype"
      </app-booking-tab-layout>

      <app-travel-comfort></app-travel-comfort>
    </div>
  </div>
</div>